// frontend/src/hooks/useNotificationSound.js
import { useState, useEffect } from 'react';
import api from '../services/api';

export function useNotificationSound() {
    const [sounds, setSounds] = useState({});
    const [loading, setLoading] = useState(true);

    // Carregar sons do backend ao montar
    useEffect(() => {
        loadSounds();
    }, []);

    const loadSounds = async () => {
        try {
            const response = await api.get('/sounds');
            const soundMap = {};

            response.data.forEach(sound => {
                soundMap[sound.service_type] = sound.file_path;
            });

            setSounds(soundMap);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao carregar sons:', error);
            setLoading(false);
        }
    };

    const playSound = (serviceType) => {
        const soundFilename = sounds[serviceType];

        if (soundFilename) {
            // Som personalizado
            const audio = new Audio(`http://localhost:5000/sounds/${soundFilename}`);
            audio.volume = 0.5;
            audio.play().catch(err => {
                console.error('Erro ao tocar som personalizado:', err);
                // Fallback para som padrão
                playDefaultSound();
            });
        } else {
            // Som padrão (base64 atual)
            playDefaultSound();
        }
    };

    const playDefaultSound = () => {
        // Som padrão em base64 (o que já existe no código)
        const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OSfTQ8MUKfj8LZjHAY4kdfyzHksBSR3x/DdkEAKFF606euoVRQKRp/g8r5sIQUqgc7y2Yk2CBtpvfDkn00PDFCn4/C2YxwGOJHX8sx5LAUkd8fw3ZBAC');
        audio.volume = 0.3;
        audio.play().catch(err => console.error('Erro ao tocar som padrão:', err));
    };

    return {
        playSound,
        loadSounds,
        sounds,
        loading,
        hasSound: (serviceType) => !!sounds[serviceType]
    };
}
